'use client';

import { cn } from '@ahm/common-helpers';

interface TabButtonProps {
  children: React.ReactNode;
  isActive: boolean;
  onClick: () => void;
}

interface ItemType {
  _id?: number | string;
  name: string;
}

interface TabNavigationProps {
  activeTab: string;
  displayItemTypes: ItemType[];
  showSearch: boolean;
  isMobile: boolean;
  onAllTabClick: () => void;
  onItemTypeClick: (itemTypeId: string) => void;
}

const TabButton = ({ children, isActive, onClick }: TabButtonProps) => (
  <button
    className={`tab-button px-4 py-3 md:px-6 md:py-4 text-sm md:text-base font-bold border-b-2 transition-colors whitespace-nowrap shrink-0 ${
      isActive
        ? 'border-[#ff8200] text-[#ff8200]'
        : 'border-transparent text-neutral-500 hover:text-neutral-70'
    }`}
    onClick={onClick}
  >
    {children}
  </button>
);

export function TabNavigation({
  activeTab,
  displayItemTypes,
  showSearch,
  isMobile,
  onAllTabClick,
  onItemTypeClick,
}: TabNavigationProps) {
  return (
    <div
      id="tabs-container"
      className={cn(
        'sticky z-20 flex bg-white border-b overflow-x-auto scrollable-tabs shadow-sm',
        isMobile
          ? showSearch
            ? 'top-[81px] px-4'
            : 'top-0 px-4'
          : showSearch
            ? 'top-[81px]'
            : 'top-0 md:top-[161px]'
      )}
    >
      <TabButton isActive={activeTab === 'all'} onClick={onAllTabClick}>
        Tất cả
      </TabButton>
      {displayItemTypes.map((type, index) => (
        <TabButton
          key={type._id ?? `type-${index}`}
          isActive={activeTab === type._id?.toString()}
          onClick={() => onItemTypeClick(type._id?.toString() ?? '')}
        >
          {type.name}
        </TabButton>
      ))}
    </div>
  );
}
